<template>
    <span>{{valorFormatado}}</span>
</template>

<script>
    import {normalizarCasasDecimais} from '@/commons/utils/CasasDecimaisUtils'

    export default {
        name: 'FormatadorMoeda',
        props: {
            valor: {
                type: Number,
            },
            casasDecimais: {
                type: Number,
            }
        },
        computed: {
            quantidadeCasasDecimais() {
                return normalizarCasasDecimais(this.casasDecimais)
            },
            valorFormatado() {
                const valor = Number(this.valor)
                const valorValido = Number.isFinite(valor) ? valor : 0
                const numArr = valorValido.toFixed(this.quantidadeCasasDecimais).split('.')
                const parteInteira = numArr[0].split('').reverse().reduce(function (acc, num, i) {
                    const separator = i && !(i % 3) ? '.' : ''
                    return num === '-' ? acc : num + separator + acc
                }, '')
                return numArr[1] === undefined ? parteInteira : parteInteira + ',' + numArr[1]
            }
        }
    }
</script>
